import { useQuery, UseQueryResult } from 'react-query';
import { DataSource } from '../types/DataSource';

const get = async (apiUrl: string): Promise<DataSource[]> => {
  if (!apiUrl) throw new Error('API URL is not configured');

  const response: Response = await fetch(`${apiUrl}/data-sources`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch data sources');
  }

  return (await response.json()) as DataSource[];
};

export const useFetchDataSources = (): UseQueryResult<DataSource[]> => {
  const apiUrl = window.BENCH?.auApi?.FIND_GLOBAL_SERVICES_API_URL || '';

  return useQuery({
    queryKey: ['getDataSources'],
    queryFn: () => get(apiUrl),
  });
};
